<template>
    <div>
        <ContactComponent/>
    </div>
</template>

<script>
import ContactComponent from '@/components/ContactComponent.vue'
    export default {
        name: 'ContactView',
        components: {
            ContactComponent,
        }
    }
</script>

<style lang="scss" scoped>

</style>